var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDai = function SvgDai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 262,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 263"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.308 121.308 0 0 0-31.249-27.288v-.006Z",
    fill: "#FDCC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z",
    fill: "#FCBB6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z",
    fill: "#FBAA48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z",
    fill: "#FB971E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z",
    fill: "#F88800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z",
    fill: "#F78700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z",
    fill: "#FDDBB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z",
    fill: "url(#dai_svg__a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z",
    fill: "url(#dai_svg__b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z",
    fill: "url(#dai_svg__c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.236ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.536 106.536 0 0 0-9 8.045A105.688 105.688 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.198 182.806v.388l-.019.014v.065h44.968a79.7 79.7 0 0 0 15.162-1.232 70.06 70.06 0 0 0 15.293-4.856c2.121-.983 4.157-2.171 6.211-3.369.52-.304 1.041-.608 1.565-.909a78.045 78.045 0 0 0 6.933-5.571 51.8 51.8 0 0 0 13.608-19.827 1.62 1.62 0 0 1 1.88-1.231h12.247c.975 0 1.297-.327 1.297-1.428v-7.842c.065-.751.065-1.512 0-2.263 0-.196.05-.392.1-.587.101-.39.201-.778-.1-1.167h-10.231c-1.236 0-1.236-.13-1.236-1.231a66.3 66.3 0 0 0 0-11.855c-.066-1.166.195-1.166 1.101-1.166h8.943c1.04 0 1.427-.261 1.427-1.297v-10.627c-.032-.704-.048-1.061-.235-1.242-.192-.186-.564-.186-1.318-.186h-11.598a1.687 1.687 0 0 1-1.936-1.362 51.964 51.964 0 0 0-5.062-9.914 62.37 62.37 0 0 0-6.932-8.616 57.184 57.184 0 0 0-11.402-8.813 63.333 63.333 0 0 0-20.28-7.516A74.047 74.047 0 0 0 122.087 68H73.495c-1.297 0-1.297.261-1.297 1.297v34.924c0 1.231-.262 1.231-1.232 1.231h-13.93c-1.036 0-1.036.192-1.036.905v11.402c0 1.036.322 1.036 1.101 1.036h14.061c1.036 0 1.036.191 1.036.97v12.181c0 1.101-.327 1.101-1.167 1.101H56v12.312c0 1.035.322 1.035 1.101 1.035h14.061c1.036 0 1.036.126 1.036.971v35.441Zm89.483-78.463a1.26 1.26 0 0 1 0 .905h.312c-.13.387-.779.517-.779.517h-74.77c-1.231 0-1.231-.261-1.231-1.231v-23c0-.844.13-1.231 1.101-1.231h34.793a48.331 48.331 0 0 1 11.015 1.166 46.575 46.575 0 0 1 19.44 9.848 15.916 15.916 0 0 1 2.981 2.916 33.092 33.092 0 0 1 4.796 6.027 25.619 25.619 0 0 1 2.342 4.083Zm3.102 28.634H86.772c-1.554 0-1.554 0-1.554-1.488v-11.532c0-.91.261-1.232 1.232-1.232h78.399c.844 0 1.231.322 1.231 1.101a75.277 75.277 0 0 1 0 12.05c-.06 1.101-.457 1.101-1.297 1.101Zm-3.102 13.478a15.031 15.031 0 0 0-3.312 0H86.515c-.97 0-1.297 0-1.297 1.297v22.486c0 1.036 0 1.297 1.297 1.297h33.174c1.587.121 3.173.009 4.726-.322a49.36 49.36 0 0 0 14.066-3.112 25.758 25.758 0 0 0 4.726-2.202h.452a42.091 42.091 0 0 0 18.078-18.199s.452-.979-.056-1.236v-.009Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.308 121.308 0 0 0-31.249-27.288v-.006Z",
    fill: "#FDCC90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z",
    fill: "#FCBB6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z",
    fill: "#FBAA48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z",
    fill: "#FB971E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z",
    fill: "#F88800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z",
    fill: "#F78700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z",
    fill: "#FDDBB1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z",
    fill: "url(#dai_svg__d)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z",
    fill: "url(#dai_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z",
    fill: "url(#dai_svg__f)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.236ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.536 106.536 0 0 0-9 8.045A105.688 105.688 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.198 182.806v.388l-.019.014v.065h44.968a79.7 79.7 0 0 0 15.162-1.232 70.06 70.06 0 0 0 15.293-4.856c2.121-.983 4.157-2.171 6.211-3.369.52-.304 1.041-.608 1.565-.909a78.045 78.045 0 0 0 6.933-5.571 51.8 51.8 0 0 0 13.608-19.827 1.62 1.62 0 0 1 1.88-1.231h12.247c.975 0 1.297-.327 1.297-1.428v-7.842c.065-.751.065-1.512 0-2.263 0-.196.05-.392.1-.587.101-.39.201-.778-.1-1.167h-10.231c-1.236 0-1.236-.13-1.236-1.231a66.3 66.3 0 0 0 0-11.855c-.066-1.166.195-1.166 1.101-1.166h8.943c1.04 0 1.427-.261 1.427-1.297v-10.627c-.032-.704-.048-1.061-.235-1.242-.192-.186-.564-.186-1.318-.186h-11.598a1.687 1.687 0 0 1-1.936-1.362 51.964 51.964 0 0 0-5.062-9.914 62.37 62.37 0 0 0-6.932-8.616 57.184 57.184 0 0 0-11.402-8.813 63.333 63.333 0 0 0-20.28-7.516A74.047 74.047 0 0 0 122.087 68H73.495c-1.297 0-1.297.261-1.297 1.297v34.924c0 1.231-.262 1.231-1.232 1.231h-13.93c-1.036 0-1.036.192-1.036.905v11.402c0 1.036.322 1.036 1.101 1.036h14.061c1.036 0 1.036.191 1.036.97v12.181c0 1.101-.327 1.101-1.167 1.101H56v12.312c0 1.035.322 1.035 1.101 1.035h14.061c1.036 0 1.036.126 1.036.971v35.441Zm89.483-78.463a1.26 1.26 0 0 1 0 .905h.312c-.13.387-.779.517-.779.517h-74.77c-1.231 0-1.231-.261-1.231-1.231v-23c0-.844.13-1.231 1.101-1.231h34.793a48.331 48.331 0 0 1 11.015 1.166 46.575 46.575 0 0 1 19.44 9.848 15.916 15.916 0 0 1 2.981 2.916 33.092 33.092 0 0 1 4.796 6.027 25.619 25.619 0 0 1 2.342 4.083Zm3.102 28.634H86.772c-1.554 0-1.554 0-1.554-1.488v-11.532c0-.91.261-1.232 1.232-1.232h78.399c.844 0 1.231.322 1.231 1.101a75.277 75.277 0 0 1 0 12.05c-.06 1.101-.457 1.101-1.297 1.101Zm-3.102 13.478a15.031 15.031 0 0 0-3.312 0H86.515c-.97 0-1.297 0-1.297 1.297v22.486c0 1.036 0 1.297 1.297 1.297h33.174c1.587.121 3.173.009 4.726-.322a49.36 49.36 0 0 0 14.066-3.112 25.758 25.758 0 0 0 4.726-2.202h.452a42.091 42.091 0 0 0 18.078-18.199s.452-.979-.056-1.236v-.009Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__a",
    x1: 52.794,
    y1: 11.51,
    x2: 213.552,
    y2: 270.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__b",
    x1: 35.627,
    y1: 16.175,
    x2: 212.351,
    y2: 233.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__c",
    x1: 197.438,
    y1: 218.181,
    x2: 64.488,
    y2: 49.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__d",
    x1: 52.794,
    y1: 11.51,
    x2: 213.552,
    y2: 270.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__e",
    x1: 35.627,
    y1: 16.175,
    x2: 212.351,
    y2: 233.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__f",
    x1: 197.438,
    y1: 218.181,
    x2: 64.488,
    y2: 49.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })))));
};
export { SvgDai as ReactComponent };
export default __webpack_public_path__ + "static/dai.360221ba.svg";